// @ts-nocheck
import React, { useState, useEffect } from 'react';
import _ from 'lodash';
import utils from '@/utils/utils';
import dd from '@/utils/dd';
import isMobile from '@/utils/isMobile';
import "./style.scss";
let ahplayer: any = null;

function VideoView(props: any) {
  const { id, data, mark, pId, mallTest } = props;
  const { auditStatus, videoUrl, mid, videoId } = data;
  const [playerStatus, setPlayerStatus] = useState(false);

  const clickVideoView = () => {
    // 点击埋点
    let extendParams = {
      ...dd.ep,
      providerId: pId,
      videoId: data.id,
      mallTest,
    };
    extendParams = utils.formatParams(extendParams);
    utils.pvTrackLogger(
      "click",
      "ec_topic_mall_shipin_click",
      dd.baseParams,
      extendParams
    );
  };

  // 插入之家播放器
  const getAutohomePlayer = () => {
    var body = document.querySelector("body");
    var script1 = document.createElement("script");
    body.appendChild(script1);
    script1.src = "//p-vp.autohome.com.cn/api/player";
    script1.onload = function () {
      setPlayerStatus(true);
    };
  };

  useEffect(() => {
    if (!!videoId && mark.pageType === "mall") {
      // 曝光埋点
      let extendParams = {
        ...dd.ep,
        providerId: pId,
        videoId: data.id,
        mallTest,
      };
      extendParams = utils.formatParams(extendParams);
      utils.pvTrackLogger(
        "show",
        "ec_topic_mall_shipin_show",
        dd.baseParams,
        extendParams
      );
    }
  }, [videoId, JSON.stringify(mark)]);

  useEffect(() => {
    if (window.AHVP && mid) {
      ahplayer = window.AHVP.newPlayer({
        mid: videoId,
        container: "playerContainer",
        width: "100%",
        height: "100%",
        // muted: true,
        // autostart: true,
        controlstype: "hide",
      });

      // 第一次播放时触发
      ahplayer &&
        ahplayer.on(window.AHVP.PLAYER_EVENT.VIDEO_START, function (e) {
          // clickVideoView();
        });
      // 暂停后，播放时触发
      ahplayer &&
        ahplayer.on(window.AHVP.PLAYER_EVENT.PLAY_RESUME, function (e) {
          // clickVideoView();
        });
    }
  }, [window.AHVP, mid]);

  useEffect(() => {
    // getAutohomePlayer();
  }, []);

  return (
    // 视频手写
    // <div className='tabHome-item'>
    //     <video
    //         src="/aaa.MP4"
    //         width="100%"
    //         height="240"
    //         style={{
    //             border: '1px solid pink'
    //         }}
    //     >
    //     </video>
    //     <div onClick={() => playVideo()}>aaaaa</div>
    //     <img src={goTop} width="100px" id="playBtn" onClick={() => playVideo()} />
    // </div>
    // 之家视频
    <div key={id} className="tabHome-item tabHome-item-video">
      <div
        id="playerContainer"
        style={{
          height: isMobile() ? 300 : "",
        }}
      />
    </div>
  );
}

export default VideoView;
